import { render } from "./Library.vue?vue&type=template&id=2be56f74&scoped=true"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"

import "./Library.vue?vue&type=style&index=0&id=2be56f74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2be56f74"

export default script